import DashboardLayout from "components/layouts/dashboard-layout";
import PageLinks from "components/page-links";
import React from "react";
import Default from "./components/default";

const RatedAfrikaPlaylist = () => {
  return (
    <DashboardLayout>
      <>
        <PageLinks
          from={{ name: "Overview", link: "/overview" }}
          current="Rated Afrika Playlist"
        />
        <Default />
      </>
    </DashboardLayout>
  );
};

export default RatedAfrikaPlaylist;
